const ITEMS = [
  "Custom tufted rugs",
  "Made to order",
  "Your ideas, beautifully tufted",
  "Characters · Gaming · Names · Logos",
  "From sketch to soft",
];

function Row({ hidden = false }: { hidden?: boolean }) {
  return (
    <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
      {ITEMS.map((t, i) => (
        <span key={i} className="flex items-center">
          <span className="px-6 font-serif text-lg sm:text-xl text-ivory/90 whitespace-nowrap">{t}</span>
          <span className="inline-block h-2 w-2 rounded-full bg-brass" aria-hidden="true" />
        </span>
      ))}
    </div>
  );
}

export function Marquee() {
  return (
    <div className="relative bg-forest texture-weave-dark border-y border-brass/30 overflow-hidden py-4" data-testid="marquee">
      <div className="flex w-max animate-marquee motion-reduce:animate-none">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
}
